export const convertActionToString = action => {
  switch (action) {
    case "new":
      return "New case created";
    case "add":
      return "Added to existing case";
    case "sup":
      return "Superseded";
    case "drop":
      return "Dismissed";
    default:
      throw new Error(`Unhandled action type: ${action}`);
  }
};
